<template>
    <div class="TeamsOverview content inner-grid-container">
        <div class="banner">
            <Banner v-bind:text="'MY TEAMS'"></Banner>
        </div>
        <div class="middle">
            <TeamCard v-bind:edit="true" v-for="team in reversedTeamsList" :key="team.id" v-bind:teamId="team.id"></TeamCard>
        </div>
    </div>
</template>


<script>
import Banner from '@/components/Banner.vue'
import TeamCard from '@/components/TeamCard.vue'
export default {
  name: 'TeamsOverview',

  components: {
    TeamCard,
    Banner
  },

  data: function(){
    return {

    }
  },


  computed: {

      teams(){
          return this.$store.state.teams;
      },

      reversedTeamsList() {
        return this.teams.slice().reverse();
  }
  },

  methods: {

  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TeamsOverview.vue